// extracted by mini-css-extract-plugin
export default {"cancel-button":"cancel-button_cancel-button__fS8P-"};